<template>
    <div class="add-danwei">
        <el-form ref="ruleForm" :model="viewData" label-width="130px">
            <el-form-item label="订单号" prop="">
                {{ viewData.order_sn }}
            </el-form-item>
            <el-form-item label="客户姓名" prop="">
                {{ viewData.customerName }}
            </el-form-item>
            <el-form-item label="联系电话" prop="">
                {{ viewData.user && viewData.user.phone }}
            </el-form-item>
            <el-form-item label="支付方式" prop="">
                {{ viewData.pay_type == 1 ? "微信支付" : "混合支付" }}
            </el-form-item>
            <el-form-item label="用户积分" prop="">
                {{
                    viewData.user_score
                }}
            </el-form-item>
            <el-form-item label="食堂积分" prop="">
                {{ viewData.yinbao_score }}
            </el-form-item>
            <el-form-item label="商城积分" prop="">
                {{ viewData.youzan_score }}
            </el-form-item>
            <el-form-item label="账单金额" prop="">
                {{ viewData.price*1/100 }}元
            </el-form-item>
            <el-form-item label="积分总抵扣" prop="">
                {{ (viewData.price * 1 - viewData.pay_price * 1 - viewData.yinbao_balance * 1) / 100 }}元
            </el-form-item>
            <el-form-item label="食堂余额抵扣" prop="">
               {{ viewData.yinbao_balance*1/100 }}元
            </el-form-item>
            <el-form-item label="最终支付金额" prop="">
               {{ viewData.pay_price*1/100 }}元
            </el-form-item>
            <el-form-item label="支付时间" prop="">
               {{ viewData.pay_at }}
            </el-form-item>
             <el-form-item label="订单详情" prop="">
               <el-table :data="viewData.detail" size="mini" style="width: 100%; min-height: 300px">
                <el-table-column prop="commName" label="小区名称" min-width="180">
                     <template slot-scope="scope">
                        <span v-if="scope.row.comm">{{
                            scope.row.comm.commName
                            }}（{{ scope.row.resourceCode }}）</span>
                    </template>
                </el-table-column>
                <el-table-column prop="costId" label="天问单号" min-width="180">
                     <template slot-scope="scope">
                        <span v-if="scope.row.detail_data">{{
                            scope.row.detail_data.costId
                            }}</span>
                    </template>
                </el-table-column>
                 <el-table-column prop="costName" label="费用名称" minWidth="140">
                    <template slot-scope="scope">
                        <span v-if="scope.row.detail_data">{{
                            scope.row.detail_data.costName
                            }}</span>
                    </template>
                </el-table-column>
                 <el-table-column prop="money" label="金额" minWidth="140">
                    <template slot-scope="scope">
                        <span>{{
                            scope.row.money*1/100
                            }}元</span>
                    </template>
                </el-table-column>
                </el-table>
            </el-form-item>
            
        </el-form>
        <div class="fix-fotter">
            <el-button style="
                    min-width: 117px;
                    background: #1067e0;
                    font-size: 16px;
                    border-color: #1067e0;
                " size="mini" type="primary" @click="$emit('onUpdateDrawer', -1)">关闭</el-button>
        </div>
    </div>
</template>

<script>
import wuye from "@/api/tianzheng/wuye";
import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
export default {
    data() {
        return {
            id: "",
            viewData: {},
        };
    },
    components: {
        Pagination,
    },
    created() { },
    mounted() { },
    methods: {
        initFun(obj) {
            let that = this;
            that.viewData = {};
            if (obj.id) {
                // 详情
                this.id = obj.id;
                wuye.detail({ id: this.id }).then((res) => {
                    that.viewData = res.result;
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.app-container {
    min-height: calc(100vh - 98px);
}
</style>
